// Stackhouse & Desserts — menu (Nashville Hot Chicken + Smash Burgers only)
// Everything else removed per user request.

export const COMBO_UPCHARGE = 2.99;

export const MENU_CATEGORIES = [
    {
        id: "nashville-hot",
        name: "Signature Chicken Meals",
        kicker: "Nashville Hot · Meals",
        copy: "Hand-breaded jumbo Nashville tenders and crispy chicken sandwiches — served as full meals with fries. Pick your heat: Southern (no heat), Nashville (medium), Inferno (extreme).",
        displayStyle: "cards",
        heatOptions: [
            { emoji: "🟢", label: "Southern", sub: "No Heat", color: "#22c55e" },
            { emoji: "🟠", label: "Nashville", sub: "Medium Heat", color: "#f97316" },
            { emoji: "🔴", label: "Inferno", sub: "Extreme Heat", color: "#ef4444" },
        ],
        items: [
            {
                name: "#1 Stackhouse Tender Meal",
                emoji: "🔥",
                desc: "Two jumbo Nashville tenders + fries. Served with Texas toast, house pickles & Stack Sauce.",
                tags: ["2 Jumbo Tenders", "Fries", "Texas Toast", "House Pickles", "Stack Sauce"],
                badge: "MEAL #1",
                badgeType: "house",
                price: 9.99,
                mealAddOns: [{ name: "Add Tender", price: 4.99 }],
            },
            {
                name: "#2 Hot Chick Sandwich Meal",
                emoji: "🐔",
                desc: "Two chicken sandwiches + fries. Crispy Nashville chicken, creamy slaw, pickles & Stack Sauce.",
                tags: ["2 Sandwiches", "Fries", "Coleslaw", "Stack Sauce"],
                badge: "MEAL #2",
                badgeType: "spicy",
                price: 15.99,
                mealAddOns: [
                    { name: "Add Sandwich", price: 6.99 },
                    { name: "Add Cheese", price: 0.99 },
                ],
            },
            {
                name: "#3 Best of Both",
                emoji: "🥩🐔",
                desc: "One tender + one chicken sandwich + fries. Perfect if you can't decide.",
                tags: ["1 Tender", "1 Sandwich", "Fries"],
                badge: "MEAL #3",
                badgeType: "signature",
                price: 14.99,
                mealAddOns: [
                    { name: "Add Tender", price: 4.99 },
                    { name: "Add Sandwich", price: 6.99 },
                ],
            },
            {
                name: "#4 Chicken Sandwich Meal",
                emoji: "🥪",
                desc: "One chicken sandwich + fries. Crispy Nashville chicken, creamy slaw, pickles & Stack Sauce.",
                tags: ["1 Sandwich", "Fries", "Coleslaw", "Stack Sauce"],
                badge: "MEAL #4",
                badgeType: "hot",
                price: 10.99,
                mealAddOns: [{ name: "Add Cheese", price: 0.99 }],
            },
        ],
    },
    {
        id: "burgers",
        name: "Smash Burgers",
        kicker: "Double Angus Patties",
        copy: "Double Certified Angus Beef Patties, smashed to order and served on a toasted brioche bun.",
        displayStyle: "cards",
        banner:
            "Double Certified Angus Beef Patties · Toasted Brioche Bun · Add Combo +$2.99",
        subsections: [
            {
                title: "Signature Burgers",
                items: [
                    {
                        name: "The Stackhouse",
                        emoji: "🍔",
                        desc: "Our signature double smash with American cheese, shredded lettuce, tomato, pickles, caramelized onions, and Stack Sauce.",
                        tags: ["American Cheese", "Caramelized Onions", "Stack Sauce"],
                        badge: "HOUSE",
                        badgeType: "house",
                        price: 13.99,
                        comboPrice: 16.98,
                    },
                    {
                        name: "Nashville Smash",
                        emoji: "🔥",
                        desc: "Double smash, pepper jack cheese, crispy onions, pickles, jalapeños, Fire Sauce, and Nashville seasoning.",
                        tags: ["Pepper Jack", "Crispy Onions", "Jalapeños", "Fire Sauce"],
                        badge: "SPICY",
                        badgeType: "spicy",
                        price: 14.49,
                        comboPrice: 17.48,
                        heat: 3,
                    },
                    {
                        name: "Smokehouse BBQ",
                        emoji: "🧀",
                        desc: "Double smash, cheddar cheese, crispy onions, smoked bacon, BBQ sauce, and Stack Sauce.",
                        tags: ["Cheddar", "Smoked Bacon", "Crispy Onions", "BBQ Sauce"],
                        price: 14.49,
                        comboPrice: 17.48,
                    },
                    {
                        name: "Truffle Melt",
                        emoji: "🍄",
                        desc: "Double smash, Swiss cheese, sautéed mushrooms, caramelized onions, garlic aioli, and fresh parsley.",
                        tags: ["Swiss", "Mushrooms", "Caramelized Onions", "Garlic Aioli"],
                        badge: "PREMIUM",
                        badgeType: "signature",
                        price: 14.99,
                        comboPrice: 17.98,
                    },
                ],
            },
        ],
        builder: {
            title: "Build Your Own Smash Burger",
            subtitle: "Double Angus Patties Included",
            basePrice: 13.99,
            comboUpcharge: 2.99,
            steps: [
                {
                    title: "Step 1 — Cheese",
                    rule: "Choose 1",
                    options: [
                        "American",
                        "Cheddar",
                        "Swiss",
                        "Pepper Jack",
                        "Provolone",
                        "Mozzarella",
                    ],
                },
                {
                    title: "Step 2 — Toppings",
                    rule: "Choose any 5",
                    options: [
                        "Lettuce",
                        "Tomato",
                        "Pickles",
                        "Red Onion",
                        "Caramelized Onions",
                        "Crispy Onions",
                        "Jalapeños",
                        "Banana Peppers",
                        "Mushrooms",
                        "Grilled Mushrooms",
                    ],
                },
                {
                    title: "Step 3 — Sauce",
                    rule: "Choose 1",
                    options: [
                        "Stack Sauce",
                        "Fire Sauce",
                        "Garlic Aioli",
                        "Chipotle Aioli",
                        "Honey Mustard",
                        "BBQ Sauce",
                        "Ranch",
                    ],
                },
            ],
            addOns: [
                { name: "Extra Patty", price: 3.0 },
                { name: "Bacon", price: 2.0 },
                { name: "Extra Cheese", price: 1.5 },
                { name: "Fried Egg", price: 2.0 },
                { name: "Avocado", price: 2.0 },
                { name: "Extra Sauce", price: 0.75 },
            ],
        },
    },
    {
        id: "crepes-waffles",
        name: "Crepes & Waffles",
        kicker: "Build Your Own",
        copy: "Pick your base — a hand-folded French crepe or a golden Belgian waffle — then load it with your picks.",
        displayStyle: "cards",
        banner:
            "Choose Any 5 Toppings · $11.99 · Extra Toppings +$1.00 Each",
        builder: {
            title: "Build Your Own Crepe or Waffle",
            subtitle: "Any 5 Toppings Included",
            note: "Extra Toppings +$1.00 each",
            basePrice: 11.99,
            steps: [
                {
                    title: "Step 1 — Base",
                    rule: "Choose 1",
                    options: ["Hand-Folded Crepe", "Belgian Waffle"],
                },
                {
                    title: "Step 2 — Spread",
                    rule: "Choose 1",
                    options: [
                        "Nutella",
                        "Biscoff Cookie Butter",
                        "Peanut Butter",
                        "White Chocolate",
                        "Milk Chocolate",
                    ],
                },
                {
                    title: "Step 3 — Fruit",
                    rule: "Choose up to 2",
                    options: [
                        "Strawberries",
                        "Bananas",
                        "Blueberries",
                        "Raspberries",
                    ],
                },
                {
                    title: "Step 4 — Sweet Toppings",
                    rule: "Choose up to 3",
                    options: [
                        "Oreo Crumbles",
                        "Biscoff Cookie Crumbles",
                        "Mini Chocolate Chips",
                        "M&M's",
                        "Rainbow Sprinkles",
                        "Crushed Graham Crackers",
                        "Chopped Peanuts",
                        "Toasted Coconut",
                    ],
                },
                {
                    title: "Step 5 — Drizzle",
                    rule: "Choose 1",
                    options: [
                        "Chocolate Sauce",
                        "White Chocolate",
                        "Caramel",
                        "Strawberry Sauce",
                        "Marshmallow Sauce",
                        "Honey",
                    ],
                },
                {
                    title: "Step 6 — Finish It Off",
                    rule: "Add both or pick one",
                    options: ["Powdered Sugar", "Whipped Cream"],
                },
            ],
            addOns: [
                { name: "Extra Fruit", price: 1.5 },
                { name: "Extra Spread", price: 1.5 },
                { name: "Ice Cream Scoop", price: 2.5 },
                { name: "Cheesecake Bites", price: 2.5 },
                { name: "Extra Drizzle", price: 0.75 },
            ],
        },
    },
    {
        id: "nyc-deli-classics",
        name: "NYC Deli Classics",
        kicker: "Choice of Hero or Roll",
        copy: "Real-deal NYC-style sandwiches — piled high, wrapped in paper, served hot. Pick a hero or a roll.",
        displayStyle: "cards",
        banner: "Choice of Hero or Roll · Add Combo +$2.99",
        items: [
            {
                name: "Chopped Cheese",
                emoji: "🥩",
                desc: "Chopped seasoned beef, melted American cheese, grilled onions, shredded lettuce, tomato, ketchup, and mayo.",
                tags: ["Chopped Beef", "American Cheese", "Grilled Onions", "Ketchup", "Mayo"],
                badge: "NYC CLASSIC",
                badgeType: "house",
                sizes: [
                    { label: "Hero", price: 11.99 },
                    { label: "Roll", price: 8.99 },
                ],
                combo: true,
            },
            {
                name: "Turkey Club",
                emoji: "🥪",
                desc: "Smoked turkey, American cheese, lettuce, tomato, pickles, mayo, and honey mustard.",
                tags: ["Smoked Turkey", "American Cheese", "Honey Mustard"],
                sizes: [
                    { label: "Hero", price: 10.99 },
                    { label: "Roll", price: 8.49 },
                ],
                combo: true,
            },
            {
                name: "Chicken Cutlet",
                emoji: "🐔",
                desc: "Crispy chicken cutlet, melted American cheese, lettuce, tomato, pickles, and Stack Sauce.",
                tags: ["Crispy Cutlet", "American Cheese", "Stack Sauce"],
                sizes: [
                    { label: "Hero", price: 11.99 },
                    { label: "Roll", price: 8.99 },
                ],
                combo: true,
            },
            {
                name: "Philly Cheesesteak",
                emoji: "🧀",
                desc: "Shaved steak, grilled onions, green peppers, and melted American cheese.",
                tags: ["Shaved Steak", "Grilled Onions", "Green Peppers", "American Cheese"],
                badge: "SIGNATURE",
                badgeType: "signature",
                sizes: [
                    { label: "Hero", price: 12.99 },
                    { label: "Roll", price: 9.49 },
                ],
                combo: true,
            },
        ],
    },
    {
        id: "sides",
        name: "Sides",
        kicker: "The Extras",
        copy: "Every meal's better with a side. Add one to any order.",
        displayStyle: "cards",
        items: [
            {
                name: "Seasoned Fries",
                emoji: "🍟",
                desc: "Crispy crinkle-cut fries seasoned with our house blend.",
                price: 3.99,
            },
            {
                name: "Loaded Fries",
                emoji: "🧀",
                desc: "Seasoned fries topped with cheese sauce and chopped pickles.",
                price: 6.99,
            },
            {
                name: "Mac & Cheese",
                emoji: "🧀",
                desc: "Creamy three-cheese blend, baked to order.",
                price: 4.49,
            },
            {
                name: "Creamy Coleslaw",
                emoji: "🥬",
                desc: "House-made slaw — cool, crunchy, tangy.",
                price: 3.49,
            },
            {
                name: "Single Tender",
                emoji: "🐔",
                desc: "One hand-breaded jumbo Nashville tender à la carte.",
                price: 4.99,
            },
            {
                name: "Single Chicken Sandwich",
                emoji: "🥪",
                desc: "One crispy Nashville chicken sandwich, no sides.",
                price: 6.99,
            },
        ],
    },
    {
        id: "drinks",
        name: "Drinks",
        kicker: "Wash It Down",
        copy: "Ice-cold sodas, refreshers, and thick milkshakes to cool the heat.",
        displayStyle: "cards",
        items: [
            {
                name: "Bottled Water",
                emoji: "💧",
                desc: "Ice-cold spring water.",
                price: 2.49,
            },
            {
                name: "Bottled Drinks",
                emoji: "🧃",
                desc: "Snapple, iced tea, juices — grab-and-go bottles.",
                price: 3.49,
            },
            {
                name: "Signature Refreshers",
                emoji: "🍹",
                desc: "House-made fruit refreshers — strawberry, mango, passion fruit.",
                badge: "HOUSE",
                badgeType: "house",
                price: 4.99,
            },
            {
                name: "Milkshakes",
                emoji: "🥤",
                desc: "Thick hand-spun milkshakes — vanilla, chocolate, strawberry, Oreo.",
                badge: "THICK",
                badgeType: "signature",
                price: 5.99,
            },
        ],
    },
    {
        id: "family-packs",
        name: "Family Packs",
        kicker: "Feed The Crew",
        copy: "Big trays for big crews. Perfect for parties, tailgates, and hungry households.",
        displayStyle: "cards",
        banner: "Feeds 4–6 People · Call Ahead for Large Orders",
        items: [
            {
                name: "Family Feast",
                emoji: "🎉",
                desc: "10 hand-breaded jumbo Nashville tenders. Add fries + drinks for a full spread.",
                tags: ["10 Tenders", "Choose Heat Level"],
                badge: "FEEDS 4–6",
                badgeType: "house",
                price: 49.99,
                reserveSms: "Hi Stackhouse — I'd like to pre-order the Family Feast (10 Tenders) for [DATE/TIME]. Please confirm availability. Thanks!",
            },
            {
                name: "Sandwich Party",
                emoji: "🥪",
                desc: "10 crispy Nashville chicken sandwiches — every sandwich made to order with your chosen heat.",
                tags: ["10 Sandwiches", "Choose Heat Level"],
                badge: "FEEDS 6–8",
                badgeType: "spicy",
                price: 64.99,
                reserveSms: "Hi Stackhouse — I'd like to pre-order the Sandwich Party (10 Chicken Sandwiches) for [DATE/TIME]. Please confirm availability. Thanks!",
            },
            {
                name: "Party Fries",
                emoji: "🍟",
                desc: "A huge tray of our seasoned crispy fries. Order alongside any pack.",
                tags: ["Large Tray", "Serves 6+"],
                badge: "ADD-ON",
                badgeType: "signature",
                price: 12.99,
                reserveSms: "Hi Stackhouse — I'd like to pre-order Party Fries (Large Tray) for [DATE/TIME]. Please confirm availability. Thanks!",
            },
        ],
    },
];
